<div class="c-modal-backdrop" (click)="dismiss()"></div>
<div class="c-modal">
  <button class="c-modal__close" (click)="dismiss()"></button>
  <ng-content></ng-content>
</div>